export default {
  title: 'Limbă',
  save_changes: 'Salvează modificările',
};
